import { render, staticRenderFns } from "./WorkSelf.vue?vue&type=template&id=e74dfc5e"
import script from "./WorkSelf.vue?vue&type=script&lang=js"
export * from "./WorkSelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports